import { Box, List, ListItem, Typography } from "@mui/material";
import type { FC } from "react";

export const KnowledgeHubContent: FC = () => {
  return (
    <Box>
      <Typography fontWeight={700} sx={{ mt: 2 }} variant="body2">
        Free HR from answering the same questions over and over.
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        The KnowledgeHub AI Agent acts as a first-line responder for employee policy and handbook
        questions.
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        Employees can ask questions in plain language—like “How much PTO do I get?”—and receive:
        <List sx={{ listStyleType: "disc", pl: 4 }}>
          <ListItem sx={{ display: "list-item" }}>A clear, direct answer</ListItem>
          <ListItem sx={{ display: "list-item" }}>
            A link to the exact policy section for full context
          </ListItem>
        </List>
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        If the agent can’t confidently answer, it escalates automatically— creating a structured
        ticket inside ChangeEngine so nothing gets lost.
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        On the HR side, AI can suggest a response for review, reducing turnaround time while keeping
        humans in control.
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        The result:
        <List sx={{ listStyleType: "disc", pl: 4 }}>
          <ListItem sx={{ display: "list-item" }}>Employees get faster answers</ListItem>
          <ListItem sx={{ display: "list-item" }}>HR handles fewer repetitive tickets</ListItem>
          <ListItem sx={{ display: "list-item" }}>
            When judgment is needed, AI speeds the response
          </ListItem>
        </List>
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        Always on. Human-led. Less reactive work.
      </Typography>
    </Box>
  );
};
